<template lang="pug">
div(class="s12 border-bottom insety-16 fund-types")
    div(class="after-16 before-8", :class="{'flex-flex' : $media.l}")
        div(class="text-semibold mf-label") {{ $t('fund_type') }}
        div(:class="$media.l? 'start-32' : 'before-16'")
            ib-radio(
                v-for="item in fundTypes",
                v-if="item.val !== 'break'",
                class="after-16 big-mobile",
                :class="{'end-16': $media.l, 'after-24': !$media.l}",
                name="fundTypes",
                v-model="selected",
                :val="item.val",
                :key="item.val"
            ) {{ item.label }}
            br(v-else-if="item.val === 'break' && $media.xl")
            span(else)
</template>

<script>
    import { mapState } from 'vuex'

    export default {
        name: 'FundType',

        data() {
            return {
                selected: 'All',
                fundTypes: [
                    { val: 'All', label: this.$t('all') },
                    { val: 'Alternatives', label: this.$t('alternatives') },
                    { val: 'Balanced', label: this.$t('balanced') },
                    { val: 'Bond', label: this.$t('bond') },
                    { val: 'Commodity', label: this.$t('commodity') },
                    { val: 'break', label: '' },//--using this to break the buttons in two lines
                    { val: 'Equity', label: this.$t('equity') },
                    { val: 'Mixed Investments', label: this.$t('mixed_investments') },
                    { val: 'Money Market', label: this.$t('money_market') },
                    { val: 'Stock', label: this.$t('stock') }
                ]
            }
        },

        computed: {
            ...mapState('fundscanner', [
                'urlFilters'
            ]),
        },

        methods: {
            reset() {
                this.selected = 'All';
            },
            showFundType() {
                this.$emit('showFundType', this.selected);
            }
        },

        mounted() {
            this.selected = this.urlFilters && this.urlFilters.itype ?
                this.urlFilters.itype : 'All';

            this.showFundType();
        },

        watch: {
            selected: {
                handler: function() {
                    this.showFundType();
                }
            }
        }
    }
</script>
<style lang="less">
@media (max-width: 600px) {
    .fund-types {
        .big-mobile {
            width: 50%;
            margin-bottom: 24px;
        }
    }
}
@media (max-width: 850px) and (orientation: landscape) {
    .fund-types {
        .big-mobile {
            width: 50%;
            margin-bottom: 24px;
        }
    }
}
</style>
